
import { Injectable } from '@angular/core';
import { AppContext } from '../../shared/app-context';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(private readonly appContext: AppContext) { }

  public prepareAPIURLBasedOnRegions(): string {
    let url = location.origin;
    url = url + this.transformURLForDev();
    url = url + this.transformURLForStaging();
    url = url + this.transformURLForProdAsia();
    url = url + this.transformURLForProdEurope();
    url = url + this.transformURLForProdAmerica();
    url = url + this.transformURLForProdForecast();
    url = url + this.transformURLForLoad();
    return url;
}

public transformURLForDev(): string {
    if (this.appContext?.apiGatewayUrl?.toLowerCase().includes('dev') && !this.appContext?.apiGatewayUrl?.toLowerCase().includes('load.emma.dev')) {
        return '/api/dev/';
      } else {
        return '';
      }
}
public transformURLForStaging(): string {
    if (this.appContext?.apiGatewayUrl?.toLowerCase().includes('staging')) {
        return '/api/staging/';
    } else {
        return '';
    }
}

public transformURLForProdAsia(): string {
    if (this.appContext?.apiGatewayUrl?.toLowerCase().includes('asia')) {
        return '/api/asia/';
    } else {
        return '';
    }
}

public transformURLForProdEurope(): string {
    if (
        this.appContext?.apiGatewayUrl?.toLowerCase().includes('europe') &&
        !this.appContext.apiGatewayUrl.toLowerCase().includes('forecast.europe')
    ) {
        return '/api/europe/';
    } else {
        return '';
    }
}

public transformURLForProdAmerica(): string {
    if (this.appContext?.apiGatewayUrl?.toLowerCase().includes('america')) {
        return '/api/america/';
    } else {
        return '';
    }
}

public transformURLForProdForecast(): string {
    if (this.appContext?.apiGatewayUrl?.toLowerCase().includes('forecast')) {
        return '/api/forecast/';
    } else {
        return '';
    }
}
public transformURLForLoad(): string {
    if (this.appContext?.apiGatewayUrl?.toLowerCase().includes('load')) {
        return '/api/load/';
    } else {
        return '';
    }
}

public transformMRDAPIURL(): string {
    const origin = location.origin;
    const apiUrl = this.appContext?.apiGatewayUrl?.toLowerCase() || '';

    let environment: 'dev' | 'staging' | '' = '';

    if (apiUrl.includes('.dev.')) {
      environment = 'dev';
    } else if (apiUrl.includes('.staging.')) {
      environment = 'staging';
    }

    return environment
      ? `${origin}/api/mrd/${environment}/`
      : `${origin}/api/mrd/`;
  }
}
